import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';
import { CheckboxStyled } from './CheckboxStyled';

const CheckboxControl = (props) => {
  return (
    <>
      <CheckboxStyled className={[`${props?.customOuterClass} ${props?.appVariant}`].join(' ')}>
        <Form.Group>
          <Form.Check
            required={props?.required}
            disabled={props?.disable}
            appVariant={props?.variant}
            checked={props?.checked}
            className={props?.className}
            name={props?.name}
            type="checkbox"
            id={props?.id}
            label={props?.label}
            onClick={props?.onClick}
            isInvalid={props?.isInvalid}
            onChange={props?.onChange}
            // isInvalid={props?.isInvalid}
          />
          {/* <Form.Control.Feedback type="invalid">{props?.errorMessage}</Form.Control.Feedback> */}
          {props?.errorMessage && <div className="invalid-feedback d-block">{props?.errorMessage}</div>}
         
        </Form.Group>
      </CheckboxStyled>
    </>
  );
};

CheckboxControl.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  appVariant: PropTypes.string,
  className: PropTypes.string,
  customOuterClass: PropTypes.string,
  disable: PropTypes.bool,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
  isInvalid: PropTypes.any,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  variant: PropTypes.string,
  outerCustomClass: PropTypes.string,
};

CheckboxControl.defaultProps = {
  variant: 'Primary',
  appVariant: '',
  id: '',
  label: '',
  className: '',
  customOuterClass: '',
  outerCustomClass: '',
};

export default CheckboxControl;
